import * as handler from './handler';
import { PATH_BACKTESTING, PATH_BACKTESTING_PROCESS, PATH_STRATEGY_PROFITABLE, PATH_SEARCH_TARGET_ASSETS } from './path';

const startBacktesting = (payload) =>
  handler.post(PATH_BACKTESTING, payload, { withCredentials: false }).then((res) => {
    return res;
  });

const backtestingProcess = (pid) =>
  handler.get(PATH_BACKTESTING_PROCESS, { pid }, { withCredentials: false }).then((res) => {
    return res;
  });

const deployBot = (strategy) =>
  handler.get(PATH_STRATEGY_PROFITABLE, { strategy }, { withCredentials: false }).then((res) => {
    return res;
  });

const getTargetAssets = (query) =>
  handler.get(PATH_SEARCH_TARGET_ASSETS, { query, limit: 10, apikey: process.env.REACT_APP_NCB_API_KEY }, { withCredentials: false }).then((res) => {
    return res;
  });

export default { startBacktesting, backtestingProcess, deployBot, getTargetAssets };
